import { z } from "zod";

export const KNOWLEDGE_TYPES = ["text", "knower", "collection"] as const;
export type AgentKnowledgeType = (typeof KNOWLEDGE_TYPES)[number];

/**
 * Knowledge item stored in Agent.knowledges Json[] field.
 * Represents inline knowledge content attached to an agent.
 *
 * type:
 *   "text"       — plain text content
 *   "knower"     — legacy AI knowledge connector
 *   "collection" — reference to a document collection (name embeds {{collection_name}} placeholder)
 */
export const AgentKnowledgeSchema = z.object({
  name: z.string(),
  content: z.string(),
  type: z.enum(KNOWLEDGE_TYPES),
  description: z.string().optional()
});

export type AgentKnowledgeItem = z.infer<typeof AgentKnowledgeSchema>;
